
import * as actionTypes from "../constants/actionTypes";

export interface SetMarketAction {
  type: "SET_MARKET";
  payload: { typeIds: Array<string> };
}
export interface ToggleMarketAction {
  type: "TOGGLE_MARKET_ON_SELECTED_LIST";
  payload: { typeId: string };
}
export type Action = SetMarketAction | ToggleMarketAction;

export function setMarket(typeIds: Array<string>): Action {
  return {
    type: actionTypes.SET_MARKET,
    payload: {
      typeIds
    }
  };
}

export function toggleMarketOnSelectedList(typeId: string): Action {
  return {
    type: actionTypes.TOGGLE_MARKET_ON_SELECTED_LIST,
    payload: {
      typeId
    }
  };
}
